/**
 * DragToZoomBoxSk is a selection box applied on top of the google chart
 * when a user ctrl click onto it. The user can drag the selection horizontally
 * and vertically and this module will estimate the difference between the
 * values based on the start and end cursor positions.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DragToZoomBox", {
    enumerable: true,
    get: function() {
        return DragToZoomBox;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
var _DragToZoomBox;
let DragToZoomBox = (_DragToZoomBox = class DragToZoomBox extends _lit.LitElement {
    render() {
        return (0, _lit.html)`<md-elevation></md-elevation>`;
    }
    /**
   * Initialize pass into helper variables to show the vertical or horizontal selection box.
   * @param chartArea key positions of the google chart. Top and bottom are used to
   * determine the max and min boundary horizontally. Left and right are determined the
   * min and max boundary vertically.
   * Height and width allow the selection to cleanly cover the chart.
   * @param start the coordinate and y value of the chart where the cursor is
   */ initializeShow(chartArea, start) {
        this.startPosition = start;
        this.style.top = `${chartArea.top}px`;
        this.style.left = `${chartArea.left}px`;
        this.boundaryInfo.width = chartArea.width;
        this.boundaryInfo.height = chartArea.height;
        this.style.display = 'block';
    }
    /**
   * Hide the module by switching the display to none
   */ hide() {
        this.style.display = 'none';
        this.style.height = `0px`;
        this.style.width = `0px`;
    }
    /**
   * Handle a drag event and update the selection area relative to the cursor start point
   * @param update the updated cursor coordinate and boolean to distinguish if
   * the direction is horizontal or vertical
   */ handleDrag(update) {
        if (update.isHorizontal) {
            const newLeft = Math.min(update.offset, this.startPosition.xOffset);
            const width = Math.abs(update.offset - this.startPosition.xOffset);
            this.style.left = `${newLeft}px`;
            this.style.width = `${width}px`;
            this.style.height = `${this.boundaryInfo.height}px`;
        } else {
            const newTop = Math.min(update.offset, this.startPosition.yOffset);
            const height = Math.abs(update.offset - this.startPosition.yOffset);
            this.style.top = `${newTop}px`;
            this.style.height = `${height}px`;
            this.style.width = `${this.boundaryInfo.width}px`;
        }
    }
    constructor(...args){
        super(...args);
        // mark the starting cursor location in the plot-google-chart
        // start represents the selection range of either top, left, bottom or right
        // we need to track the start coordinate because getBoundingClientRect
        // is with respect to the viewport
        this.startPosition = {
            xOffset: 0,
            yOffset: 0
        };
        // store the chart boundary information in the plot-google-chart
        this.boundaryInfo = {
            width: 0,
            height: 0
        };
    }
}, (()=>{
    _DragToZoomBox.styles = (0, _lit.css)`
    :host {
      display: none;
      position: absolute; /* note: this interferes with calculating offsetY */
      border-style: solid;
      border-width: 1px;
      border-color: rgb(255 99 71 / 40%); /* almost orange red color */
      background-color: rgb(255 99 68 / 40%); /* semi-transparent shade of orange hue */

      --md-elevation-level: 1;

      cursor: magnifying glass;
    }
  `;
})(), _DragToZoomBox);
_ts_decorate([
    (0, _decorators.property)()
], DragToZoomBox.prototype, "startPosition", void 0);
_ts_decorate([
    (0, _decorators.property)()
], DragToZoomBox.prototype, "boundaryInfo", void 0);
DragToZoomBox = _ts_decorate([
    (0, _decorators.customElement)('drag-to-zoom-box-sk')
], DragToZoomBox);
